import React, { useEffect, useState } from 'react';

// Vendor Components
import sanityClient from '../../sanity-client.js';
import { Container } from 'react-bootstrap';

// Components
import FullpageImage from '../../components/FullpageImageSelector';
import Loading from '../../components/Loading';

import './style.scss';

function App() {
  const [postData, setPostData] = useState(null);

  useEffect(() => {
    sanityClient

      // .fetch(`*[slug.current == "${slug}"]`)
      .fetch(
        `* [_id == "frontpage"] {
					title,
          mastheadImages [] {
            asset -> {
							_id,
							url,
							metadata {
								palette,
								dimensions {
									aspectRatio
								},
								lqip
							},
						},
						alt,
          },
          mastheadLinks []-> {
            slug
          },
					slides [] {
						alt,
						title,
						linkTo ->{
							slug
						},
						asset -> {
							_id,
							url,
							metadata {
								dimensions {
									aspectRatio
								},
								lqip
							},
						},
					}
				}`
      )
      .then((data) => setPostData(data[0]))
      .catch(console.error);
  }, []);

  if (!postData) return <Loading />;

  return (
    <Container fluid id="homepage">
      <FullpageImage masthead mastheadImages={postData.mastheadImages} nav={postData.mastheadLinks} {...postData} />
      {postData.slides &&
        postData.slides.map((slide, index) => {
          return <FullpageImage key={index} title={slide.title} image={slide.asset} link={slide.linkTo.slug.current} />;
        })}
    </Container>
  );
}

export default App;
